global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    $(function() {
        AOS.init({
            duration: 600,
            offset: 100,
            delay: 400,
            mirror: true,
            once: true,
        });
    });

    const linkServizi = $('.link-servizi');
    let desktopServizi = $('.sub-menu-services');

    linkServizi.on({
        mouseenter: function () {
            if (!linkServizi.hasClass('opened')){
                linkServizi.addClass('opened')
                desktopServizi.stop().slideDown('slow');
            }
        },
        mouseleave: function () {
            if (linkServizi.hasClass('opened')){
                linkServizi.removeClass('opened')
                desktopServizi.stop().slideUp('slow');
            }
        }
    });

    const linkSociale = $('.link-sociale');
    let desktopSociale = $('.link-sociale .header__nav-submenu-wrapper');

    linkSociale.on({
        mouseenter: function () {
            if (!linkSociale.hasClass('opened')){
                linkSociale.addClass('opened')
                desktopSociale.stop().slideDown();
            }
        },
        mouseleave: function () {
            if (linkSociale.hasClass('opened')){
                linkSociale.removeClass('opened')
                desktopSociale.stop().slideUp();
            }
        }
    });

    let burgerButton = $('.burger-button');
    let mainMenu = $('.menu-mobile');
    let btx = $('.bi-x');
    let btmenu = $('.bi-list');
    burgerButton.on( "click", function(event) {
        event.preventDefault()
        if (!burgerButton.hasClass('opened')){
            btx.removeClass('d-none')
            btmenu.addClass('d-none')
            burgerButton.addClass('opened')
            event.preventDefault()
            mainMenu.stop().slideDown('slow');
            $('body').addClass('overflow-hidden')
            event.stopPropagation()
        } else {
            event.preventDefault()
            btx.addClass('d-none')
            btmenu.removeClass('d-none')
            burgerButton.removeClass('opened')
            event.preventDefault()
            mainMenu.stop().slideUp('slow');
            $('body').removeClass('overflow-hidden')
            event.stopPropagation()
        }
    });

    $('.submenu-trigger').on('click', function (e) {
        e.preventDefault();

        const $trigger = $(this);
        const $submenu = $trigger.closest('.header__item-has-submenu').find('.header__nav-submenu-wrapper');
        if ($submenu.is(':visible')) {
            $submenu.stop().slideUp('slow');
            $trigger.removeClass('opened');
        } else {
            $submenu.stop().slideDown('slow');
            $trigger.addClass('opened');
        }
    });

    if ($('.page-contatti').length){
        async function initMap() {
            let locations = [
                ['0','Sede operativa', 'Via Torino, 151/F 30172 Mestre Venezia', {lat: 45.48009042004463, lng: 12.253851728835517}],
                ['1','Sede legale', 'San Marco, 5291 30124 Venezia', {lat: 45.43639980500993, lng: 12.335536372907262}],
            ];

            // Request libraries when needed, not in the script tag.
            const { Map } = await google.maps.importLibrary("maps");
            const myLatLng = { lat: 45.48009042004463, lng: 12.253851728835517 };
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            // Short namespaces can be used.
            let map = new Map(document.getElementById("map"), {
                center: myLatLng,
                zoom: 10,
                mapId: 'mapsCastellanoID'
            });

            let marker;

            locations.forEach((item) => {
                let pin = document.createElement("i");
                pin.className = "bi bi-geo-alt-fill color-green";
                pin.style.fontSize = "35px";

                marker = new AdvancedMarkerElement({
                    content: pin,
                    position: item[3],
                    map: map,
                });

                google.maps.event.addListener(marker, 'click', function() {
                    map.panTo(item[3]);
                    map.setZoom(19);
                });
            });

            $('.city').on('click', function() {
                let position = {lat: parseFloat($(this).attr('data-lat')), lng: parseFloat($(this).attr('data-lng'))}
                map.panTo(position);
                map.setZoom(19);
            });
        }
        initMap();
    }
});
